import React, { useRef, useState, useEffect } from 'react';
import { Tooltip } from 'antd';

const EllipsisTooltip = ({ text, children }) => {
  const ref = useRef(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (el) {
      setIsOverflowed(el.scrollWidth > el.clientWidth);
    }
  }, [text]);

  return (
    <Tooltip title={isOverflowed ? text : ''}>
      <div className='text-truncate' ref={ref}>
        {children}
      </div>
    </Tooltip>
  );
};

export default EllipsisTooltip;
